// export const  post_id = '9263'

export function getPostId() {
    let href = window.location.href;
    // 去掉 hash 和 search
    let cleanHref = href.split('#')[0].split('?')[0];
    // 兼容 /sites/数字.html 和 /数字.html
    let match = cleanHref.match(/(?:\/sites)?\/(\d+)\.html$/);
    let post_id = match ? match[1] : null;
    // console.log(href);
    // console.log(post_id);
    return post_id;
}


export function base_url(){
    const hostname = window.location.hostname;
    const base_url = "https://" + hostname;
    return base_url
}